import { useState } from 'react';
import { getRecommendList, type RecommendProductListRecord } from '@/service/service-renewal';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import { RecommendProductItem } from './types';
const useRecommendList = () => {
    const [productsDetail, setProductsDetail] = useState<RecommendProductItem[]>([]);

    const fetchRecommendList = async (campaignId: number, locale: string) => {
        let variantIds: string[] = [];
        try {
            const res = await getRecommendList({ campaignId }, locale);
            if(res.data && Array.isArray(res.data)) {
                variantIds = res.data?.map((item: RecommendProductListRecord) => item.variantId) || [];
            }
        } catch (e) {
            setProductsDetail([]);
            return
        }

        if(variantIds.length === 0) return;

        try {
            const res = await getSolarRecommand2({ variantIds }, locale);
            if(res.data && Array.isArray(res.data)) {
                setProductsDetail(res.data);
            }else{
                setProductsDetail([]);
            }
        } catch (e) {
            setProductsDetail([]);
        }
    };

    return { fetchRecommendList, productsDetail };
};

export default useRecommendList;
